import api, { buildTicketedWebSocketURL } from "../../api/api";
import { getAccessToken } from "../../auth/tokenStore";
import { clearWebSocketStatus, handleWebSocketClose } from "../../auth/websocketLifecycle";
import { setFlaggedPageCount } from "../../Redux/general/actions";
import store from "../../Redux/store";

import {
  createFlaggedCaseCountConnection,
  FLAGGED_CASES_SOCKET_PATH,
} from "./flaggedCaseCountConnection.mjs";

let active = null;

// Capture before a request starts. If a socket update or another session wins
// while it is in flight, its older HTTP count must not replace the live badge.
export const captureFlaggedCaseCountUpdate = (userId) => {
  const session = active;
  const revision = session?.connection.getRevision();
  return (count) => {
    if (!session || active !== session || String(session.userId) !== String(userId)) return false;
    return session.connection.applyCount(count, revision);
  };
};

export const startFlaggedCaseCount = (userId, dispatch) => {
  active?.connection.dispose();
  dispatch(setFlaggedPageCount(0));
  const connection = createFlaggedCaseCountConnection({
    userId,
    requestCount: async () => (await api.get("/api/flaggedpage/notification-count/")).data.count,
    requestSocketURL: () => buildTicketedWebSocketURL(FLAGGED_CASES_SOCKET_PATH),
    createSocket: (url) => new WebSocket(url),
    onCount: (count) => dispatch(setFlaggedPageCount(count)),
    onOpen: () => clearWebSocketStatus(FLAGGED_CASES_SOCKET_PATH),
    canReconnect: (event) => handleWebSocketClose(event, FLAGGED_CASES_SOCKET_PATH),
    isCurrentSession: () =>
      Boolean(getAccessToken()) &&
      String(store.getState().authPermissions?.subjectUserId) === String(userId),
  });
  active = { userId, connection };
  return () => {
    connection.dispose();
    if (active?.connection === connection) {
      active = null;
      dispatch(setFlaggedPageCount(0));
    }
  };
};
